import { render } from "./BACSuccess.vue?vue&type=template&id=316271b9&scoped=true"
import script from "./BACSuccess.vue?vue&type=script&lang=js"
export * from "./BACSuccess.vue?vue&type=script&lang=js"

import "./BACSuccess.vue?vue&type=style&index=0&id=316271b9&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-316271b9"]])

export default __exports__